import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">话题广场</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">热门话题一网打尽，找到和你志同道合的漫友</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200 text-foreground-600 hover:border-primary-200 hover:text-primary-600'
              }`}
            >
              {topic.hot && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-fill text-accent-500 text-xs"></i>
                </span>
              )}
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-500'}`}>{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}